/**
 * Precio base desde el objeto de suscripción (GET /suscripcions/:id).
 */
const subscriptionBasePrice = info => {
  if (!info || typeof info !== "object") return null
  const keys = [
    "precioRedondeado",
    "precioConIVA",
    "precioSinIVA",
    "precio",
    "precioMensual",
    "monto",
    "mensualidad",
    "price",
    "precioBase",
    "importe",
    "valor",
    "costo",
  ]
  for (const k of keys) {
    if (info[k] != null && !Number.isNaN(Number(info[k]))) {
      return Number(info[k])
    }
  }
  return null
}

export { subscriptionBasePrice }
